module.exports = __webpack_public_path__ + "static/media/shoulders1.dd819594.png";